import moment from 'moment';
import ChangeModel from 'models/common/ChangeModel';
import DateFormatter from 'utils/date/DateFormatter';

let Pregnancysnapshot = ChangeModel.extend({
    backend: 'gcapi',

    parse(resp) {
        if (resp && resp.originalDueDate) {
            this.originalDueDate = resp.originalDueDate;
        }
        return resp;
    },

    url() {
        return `/periodichealth-service/menstrualcycle/pregnancysnapshot${
            this.originalDueDate ? '/' + this.originalDueDate : ''
        }`;
    },

    setOriginalDueDate(originalDueDate) {
        this.originalDueDate = originalDueDate;
    },

    isNew() {
        // Need to do a PUT
        return false;
    },

    setTitle(title) {
        this.set('title', title);
    },

    getTitle() {
        return this.get('title');
    },

    setDueDate(dueDate) {
        this.set('dueDate', moment(dueDate).format(DateFormatter.LINK_FORMAT));
    },

    getDueDate() {
        return this.get('dueDate');
    },

    getPregnancyStart() {
        return this.get('pregnancyCycleStart');
    },

    setDeliveryDate(deliveryDate) {
        this.set('deliveryDate', moment(deliveryDate).format(DateFormatter.LINK_FORMAT));
    },

    setDeliveryDate() {
        return this.get('deliveryDate');
    },

    setNumberOfBabies(numberOfBabies) {
        this.set('numOfBabies', numberOfBabies);
    },

    getNumberOfBabies() {
        return this.get('numOfBabies');
    },

    setPrePregnancyWeight(weight) {
        this.set('prePregnancyWeight', weight);
    },

    getPrePregnancyWeight() {
        return this.get('prePregnancyWeight');
    },

    setTerminated(terminated) {
        this.set('terminated', terminated);
    },

    getTerminated() {
        return this.get('terminated');
    },

    setEndDate(endDate) {
        this.set('endDate', moment(endDate).format(DateFormatter.LINK_FORMAT));
        this.set(
            'terminationReportTimestamp',
            moment()
                .utc(endDate)
                .format()
        );
    },

    getEndDate() {
        return this.get('endDate');
    },

    setStopTracking(endDate) {
        this.set('stopTracking', endDate);
        this.set(
            'stopTrackingTimestamp',
            moment()
                .utc(new Date())
                .format()
        );
    },

    getStopTracking() {
        return this.get('stopTracking');
    },

    setNotes(notes) {
        this.set('notes', notes);
    },

    getNotes() {
        return this.get('notes');
    },

    setWeightGoalUserInputs(weightGoalRecommendation, weightInGram = 0, heightInCm = 0) {
        let inputs = this.get('weightGoalUserInputs');
        if (typeof inputs === 'undefined') {
            inputs = {};
            this.set('weightGoalUserInputs', inputs);
        }

        inputs.weightGoalRecommendation = weightGoalRecommendation;
        inputs.reportTimestamp = DateFormatter.formatConnectTimestampUTC(moment().toDate());
        if (weightGoalRecommendation) {
            inputs.heightInCm = heightInCm;
            inputs.weightInGram = weightInGram;
        }
        this.set('weightGoalUserInputs', inputs); // flag a change
    },

    getWeightGoalUserInputs() {
        return this.get('weightGoalUserInputs');
    },

    save(attributes, options) {
        this.set('reportTimestamp', DateFormatter.formatConnectTimestampUTC(moment().toDate()));

        ChangeModel.prototype.save.call(this, attributes, options);
    }
});

export default Pregnancysnapshot;
